import Card from "../../../../components/Card.jsx";
import React from "react";
import {useListSchedulazioni} from "./useListSchedulazioni";
import TabellaSchedulazioni from "./components/TabellaSchedulazioni";

export default function ListSchedulazioni() {

    const {getBottoniDx} = useListSchedulazioni();

    return (
        <Card
            icon={'fas fa-calendar-alt'}
            title={'Schedulazioni'}
            getBottoniDx={getBottoniDx}
        >
            <TabellaSchedulazioni/>
        </Card>
    );

}